import React, { useContext, useState, useEffect } from 'react';
import { useProfileData } from '../../NecttosComp/APICaller/queryHooks';
import { Body, Main, Header } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import HandleProceed from './HandleProceed';






function VerificationStudent({ userId, isStudent, keyData, TimerFuncion, stateData, setStateData, parentOnClose, onClose, toast }) {

  const { data: userDetail } = useProfileData(userId, !isStudent);

  const [state, setState] = useState({});
  const [verifications, setVerifications] = useState({
    personal: false,
    address: false,
    academic: false,
    certificates: false,
  });

  // Fix for double close issue
  const handleClose = () => {
    onClose();
  };

  const profile = userDetail;
  const allChecked = Object.values(verifications).every(Boolean);

  const handleCheck = (section) => {
    setVerifications((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const handleProceed = async () => {
    setState({ ...state, handleProceed: true });
  };

  if (!userId || !userDetail) {
    return (
      <div className='flex items-center justify-center h-full'>
        <div className="text-center p-8 rounded-xl bg-slate-100 dark:bg-slate-800 shadow-lg">
          <div className="animate-spin w-10 h-10 border-4 border-blue-500 dark:border-blue-400 border-t-transparent rounded-full mx-auto mb-4"></div>
          <div className='text-lg font-semibold text-slate-700 dark:text-slate-200'>
            Loading student data...
          </div>
          <p className="text-sm text-slate-500 dark:text-slate-400 mt-2">
            Please wait while we fetch the student records
          </p>
        </div>
      </div>
    );
  }

  return (
    <Main width='95vw' height='90vh' title='Student Verification'>
      <Header>
        <div className="flex items-center">
          <h1 className="text-xl font-semibold text-slate-800 dark:text-slate-100">
            Student Verification
            <span className="ml-2 text-sm font-normal text-slate-500 dark:text-slate-400">
              #{profile?.applicationNo}
            </span>
          </h1>
        </div>
        <div className='flex justify-end gap-3'>
          <Button
            type='close'
            onClick={handleClose}
            className="bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-200 transition-all duration-200"
          >
            Cancel
          </Button>
          <Button
            type='complete'
            onClick={handleProceed}
            disabled={!allChecked}
            className={`${!allChecked ? 'opacity-60 cursor-not-allowed' : 'hover:shadow-lg transform hover:-translate-y-0.5'} 
              bg-blue-600 hover:bg-blue-700 text-white transition-all duration-300`}
          >
            <div className="flex items-center gap-2">
              {allChecked && (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              )}
              Complete Verification
            </div>
          </Button>
        </div>
      </Header>

      <Body>
        <div className="flex flex-col md:flex-row gap-6 h-full overflow-hidden px-4 py-4 rounded-lg bg-slate-100 dark:bg-slate-900 shadow-sm">

          {/* Profile Card - Top section in mobile view */}
          <div className="md:hidden w-full bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-slate-800 dark:to-slate-700 rounded-xl p-5 shadow-sm mb-4">
            <div className="flex items-center gap-4">
              <img
                src={profile?.photoURL || '/default-student.png'}
                alt={profile?.name || 'Student'}
                className="w-20 h-20 object-cover rounded-full border-4 border-white dark:border-slate-600 shadow-md"
              />
              <div>
                <h2 className="text-xl font-bold text-slate-800 dark:text-white">{profile?.name}</h2>
                <p className="text-blue-600 dark:text-blue-400 font-medium">{profile?.shortName} | {profile?.batchName}</p>
                <div className="flex mt-2">
                  <span className="text-xs px-2 py-1 bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300 rounded-full">
                    {profile?.applicationNo}
                  </span>
                </div>
              </div>
            </div>
          </div>


          <div className="w-full md:w-1/2 flex flex-col gap-4 overflow-auto pr-3 max-h-[calc(90vh-120px)] scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-slate-600">

            <div className="hidden md:block bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-slate-800 dark:to-slate-700 rounded-xl p-5 shadow-sm transition-all duration-200 hover:shadow-md">
              <div className="flex items-start gap-4">
                <img
                  src={profile?.photoURL || '/default-student.png'}
                  alt={profile?.name || 'Student'}
                  className="w-24 h-24 object-cover rounded-lg border-4 border-white dark:border-slate-600 shadow-md"
                />
                <div>
                  <h2 className="text-xl font-bold text-slate-800 dark:text-white">{profile?.name}</h2>
                  <div className="grid grid-cols-2 text-sm text-slate-600 dark:text-slate-300 gap-y-1 mt-2">
                    <span className="font-medium">Application No:</span> <span className="font-semibold text-blue-600 dark:text-blue-400">{profile?.applicationNo}</span>
                    <span className="font-medium">Course:</span> <span>{profile?.shortName}</span>
                    <span className="font-medium">Batch:</span> <span>{profile?.batchName}</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-slate-100 dark:bg-slate-800 rounded-xl p-5 shadow-sm border border-slate-100 dark:border-slate-700">
              <h3 className="text-sm uppercase font-semibold text-slate-500 dark:text-slate-400 mb-3">
                Verification Progress
              </h3>
              <div className="w-full bg-slate-200 dark:bg-slate-700 rounded-full h-2.5 mb-4">
                <div
                  className="bg-green-500 h-2.5 rounded-full transition-all duration-500 ease-out"
                  style={{ width: `${(Object.values(verifications).filter(Boolean).length / 4) * 100}%` }}
                ></div>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-xs">
                {Object.entries(verifications).map(([key, value]) => (
                  <div
                    key={key}
                    className={`flex items-center gap-1 rounded-lg p-1 ${value ? 'text-green-700 dark:text-green-400' : 'text-slate-500 dark:text-slate-400'}`}
                  >
                    {value ? (
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    )}
                    <span className="capitalize">{key}</span>
                  </div>
                ))}
              </div>
            </div>

            <section className="bg-slate-100 dark:bg-slate-800 rounded-xl p-5 shadow-sm border border-slate-100 dark:border-slate-700 transition-all duration-200 hover:shadow-md">
              <div className="flex justify-between items-center mb-3 border-b border-gray-200 dark:border-slate-700 pb-2">
                <h3 className="text-lg font-semibold text-slate-700 dark:text-slate-200">
                  Personal Information
                </h3>
                <div className={`h-6 w-6 rounded-full flex items-center justify-center ${verifications.personal ? 'bg-green-100 dark:bg-green-900/30' : 'bg-slate-100 dark:bg-slate-700'}`}>
                  {verifications.personal ? (
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-green-600 dark:text-green-400" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-slate-400 dark:text-slate-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 9l4-4 4 4m0 6l-4 4-4-4" />
                    </svg>
                  )}
                </div>
              </div>
              <div className="grid grid-cols-2 text-sm text-slate-600 dark:text-slate-300 gap-y-3">
                <span className="font-medium">Gender:</span> <span>{profile?.gender}</span>
                <span className="font-medium">Date of Birth:</span> <span>{profile?.dob}</span>
                <span className="font-medium">Blood Group:</span> <span>{profile?.bloodGroup}</span>
                <span className="font-medium">Nationality:</span> <span>{profile?.nationality}</span>
                <span className="font-medium">Religion:</span> <span>{profile?.religion}</span>
                <span className="font-medium">Caste:</span> <span>{profile?.caste}</span>
                <span className="font-medium">Category:</span> <span>{profile?.category}</span>
              </div>

              <div className="mt-4 p-3 bg-blue-50 dark:bg-blue-900/10 rounded-lg border border-blue-100 dark:border-blue-900/30">
                <label className="flex items-center gap-2 text-sm font-medium text-slate-700 dark:text-slate-200 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={verifications.personal}
                    onChange={() => handleCheck('personal')}
                    className="w-4 h-4 text-blue-600 dark:text-blue-500 rounded focus:ring-blue-500 dark:focus:ring-blue-400 focus:ring-2"
                  />
                  I confirm the personal information is accurate
                </label>
              </div>
            </section>

            <section className="bg-slate-100 dark:bg-slate-800 rounded-xl p-5 shadow-sm border border-slate-100 dark:border-slate-700 transition-all duration-200 hover:shadow-md">
              <div className="flex justify-between items-center mb-3 border-b border-gray-200 dark:border-slate-700 pb-2">
                <h3 className="text-lg font-semibold text-slate-700 dark:text-slate-200">
                  Permanent Address
                </h3>
                <div className={`h-6 w-6 rounded-full flex items-center justify-center ${verifications.address ? 'bg-green-100 dark:bg-green-900/30' : 'bg-slate-100 dark:bg-slate-700'}`}>
                  {verifications.address ? (
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-green-600 dark:text-green-400" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-slate-400 dark:text-slate-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 9l4-4 4 4m0 6l-4 4-4-4" />
                    </svg>
                  )}
                </div>
              </div>
              <div className="grid grid-cols-2 text-sm text-slate-600 dark:text-slate-300 gap-y-3">
                <span className="font-medium">House:</span> <span>{profile?.permanentHouseName}</span>
                <span className="font-medium">Place:</span> <span>{profile?.permanentPlace}</span>
                <span className="font-medium">Post Office:</span> <span>{profile?.permanentPostOffice}</span>
                <span className="font-medium">Taluk:</span> <span>{profile?.permanentTaluk}</span>
                <span className="font-medium">District:</span> <span>{profile?.permanentDistrict}</span>
                <span className="font-medium">State:</span> <span>{profile?.permanentState}</span>
                <span className="font-medium">Pin Code:</span> <span>{profile?.permanentPinCode}</span>
              </div>

              <div className="mt-4 p-3 bg-blue-50 dark:bg-blue-900/10 rounded-lg border border-blue-100 dark:border-blue-900/30">
                <label className="flex items-center gap-2 text-sm font-medium text-slate-700 dark:text-slate-200 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={verifications.address}
                    onChange={() => handleCheck('address')}
                    className="w-4 h-4 text-blue-600 dark:text-blue-500 rounded focus:ring-blue-500 dark:focus:ring-blue-400 focus:ring-2"
                  />
                  I confirm the address information is accurate
                </label>
              </div>
            </section>

            <section className="bg-slate-100 dark:bg-slate-800 rounded-xl p-5 shadow-sm border border-slate-100 dark:border-slate-700 transition-all duration-200 hover:shadow-md mb-4">
              <div className="flex justify-between items-center mb-3 border-b border-gray-200 dark:border-slate-700 pb-2">
                <h3 className="text-lg font-semibold text-slate-700 dark:text-slate-200">
                  Academic Records
                </h3>
                <div className={`h-6 w-6 rounded-full flex items-center justify-center ${verifications.academic ? 'bg-green-100 dark:bg-green-900/30' : 'bg-slate-100 dark:bg-slate-700'}`}>
                  {verifications.academic ? (
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-green-600 dark:text-green-400" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-slate-400 dark:text-slate-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 9l4-4 4 4m0 6l-4 4-4-4" />
                    </svg>
                  )}
                </div>
              </div>
              <div className="grid grid-cols-2 text-sm text-slate-600 dark:text-slate-300 gap-y-3">
                <span className="font-medium">SSLC %:</span> <span>{profile?.sslcPercentage}</span>
                <span className="font-medium">SSLC Reg No:</span> <span>{profile?.sslcRegisterNo}</span>
                <span className="font-medium">+2 %:</span> <span>{profile?.plusTwoPercentage}</span>
                <span className="font-medium">+2 Reg No:</span> <span>{profile?.plusTwoRegisterNo}</span>
                <span className="font-medium">Institution:</span> <span>{profile?.plusTwoInstitutionName}</span>
              </div>

              <div className="mt-4 p-3 bg-blue-50 dark:bg-blue-900/10 rounded-lg border border-blue-100 dark:border-blue-900/30">
                <label className="flex items-center gap-2 text-sm font-medium text-slate-700 dark:text-slate-200 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={verifications.academic}
                    onChange={() => handleCheck('academic')}
                    className="w-4 h-4 text-blue-600 dark:text-blue-500 rounded focus:ring-blue-500 dark:focus:ring-blue-400 focus:ring-2"
                  />
                  I confirm the academic records are accurate
                </label>
              </div>
            </section>
          </div>

          <div className="w-full md:w-1/2 flex flex-col gap-4 overflow-auto max-h-[calc(90vh-120px)] pr-2 scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-slate-600">
            <section className="bg-slate-100 dark:bg-slate-800 rounded-xl p-5 shadow-sm border border-slate-100 dark:border-slate-700 transition-all duration-200 hover:shadow-md mb-2">
              <div className="flex justify-between items-center mb-3 border-b border-gray-200 dark:border-slate-700 pb-2">
                <h3 className="text-lg font-semibold text-slate-700 dark:text-slate-200">
                  Uploaded Certificates
                </h3>
                <div className={`h-6 w-6 rounded-full flex items-center justify-center ${verifications.certificates ? 'bg-green-100 dark:bg-green-900/30' : 'bg-slate-100 dark:bg-slate-700'}`}>
                  {verifications.certificates ? (
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-green-600 dark:text-green-400" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-slate-400 dark:text-slate-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 9l4-4 4 4m0 6l-4 4-4-4" />
                    </svg>
                  )}
                </div>
              </div>

              {Array.isArray(profile?.documents) && profile.documents.length > 0 ? (
                <div className="grid grid-cols-1 gap-5 overflow-auto">
                  {profile.documents.map((doc, idx) => (
                    <div key={idx} className="flex flex-col items-start p-3 border border-slate-200 dark:border-slate-700 rounded-lg bg-slate-100 dark:bg-slate-800/80 hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-colors duration-200 shadow-sm hover:shadow-md">
                      <p className="text-sm font-medium text-slate-700 dark:text-slate-300 mb-2 flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1 text-blue-500 dark:text-blue-400" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" clipRule="evenodd" />
                        </svg>
                        {doc?.title || `Document ${idx + 1}`}
                      </p>
                      {doc?.url ? (
                        <div className="w-full relative group">
                          <img
                            src={doc.url}
                            alt={`Document ${idx + 1}`}
                            className="w-full max-w-lg rounded-md border border-slate-200 dark:border-slate-600 shadow-sm hover:shadow-md transition-shadow duration-200"
                          />
                          <a
                            href={doc.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="absolute bottom-2 right-2 bg-slate-100 dark:bg-slate-800 p-2 rounded-full shadow-md text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-slate-700 transition-colors opacity-0 group-hover:opacity-100 duration-200"
                            title="View full size"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                            </svg>
                          </a>
                          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 dark:group-hover:bg-slate-100/5 transition-colors duration-200 pointer-events-none"></div>
                        </div>
                      ) : (
                        <div className="w-full text-sm text-red-500 bg-red-50 dark:bg-red-900/20 p-3 rounded-md flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                          </svg>
                          No document available
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center p-6 bg-slate-50 dark:bg-slate-700/30 rounded-lg border border-dashed border-slate-300 dark:border-slate-600">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto text-slate-400 dark:text-slate-500 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <p className="text-slate-500 dark:text-slate-400">No certificate documents available</p>
                  <p className="text-xs text-slate-400 dark:text-slate-500 mt-1">The student has not uploaded any certificates yet</p>
                </div>
              )}

              <div className="mt-6 p-3 bg-blue-50 dark:bg-blue-900/10 rounded-lg border border-blue-100 dark:border-blue-900/30">
                <label className="flex items-center gap-2 text-sm font-medium text-slate-700 dark:text-slate-200 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={verifications.certificates}
                    onChange={() => handleCheck('certificates')}
                    className="w-4 h-4 text-blue-600 dark:text-blue-500 rounded focus:ring-blue-500 dark:focus:ring-blue-400 focus:ring-2"
                  />
                  I confirm the certificate details are accurate
                </label>
              </div>
            </section>

            {allChecked && (
              <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800/50 rounded-xl p-4 shadow-sm mb-4 animate-fadeIn">
                <div className="flex items-center gap-2 text-green-700 dark:text-green-400">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="font-medium">All sections verified!</span>
                </div>
                <p className="text-sm text-green-600 dark:text-green-300 mt-1 ml-7">
                  You can now complete the verification process using the button above.
                </p>
              </div>
            )}

            {/* Final Action Notice */}
            <div className="bg-blue-50 dark:bg-blue-900/10 border border-blue-100 dark:border-blue-900/20 rounded-xl p-4 shadow-sm">
              <h4 className="font-medium text-blue-700 dark:text-blue-400 flex items-center gap-2 mb-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2h-1V9z" clipRule="evenodd" />
                </svg>
                Verification Process
              </h4>
              <p className="text-sm text-blue-600 dark:text-blue-300 ml-7">
                Please review all sections carefully before submitting. Once verified,
                the student will be notified of their verification status.
              </p>
            </div>
          </div>
        </div>
      </Body>

      {state?.handleProceed && (
        <HandleProceed
          userId={userId}
          isStudent={true}
          keyData={keyData}
          stateData={state}
          setStateData={setState}
          parentOnClose={onClose}
          toast={toast}
          onClose={() => {
            setState({ ...state, handleProceed: false });
            setTimeout(() => {
              if (parentOnClose) parentOnClose();
              onClose();
            }, 100);
          }}

        />
      )}
    </Main>
  );
}

export default VerificationStudent;